import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import LoadingOverlay from "./LoadingOverlay";
import { showAccessDenied, showNoPermission } from "../../../redux/actions/accessActions";

interface ProtectedRouteProps {
	children: JSX.Element;
	requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
	const dispatch = useDispatch();
	const { authReady, userName, userRole } = useSelector((state: RootState) => state.auth);
	const [allowRender, setAllowRender] = useState(false);
	const [redirect, setRedirect] = useState(false);

	useEffect(() => {
		if (!authReady) return;

		const isManualLogout = sessionStorage.getItem("logoutManual") === "true";

		// Usuario no autenticado
		if (!userName) {
			if (!isManualLogout) {
				dispatch(showAccessDenied());
			} else {
				sessionStorage.removeItem("logoutManual");
			}
			setRedirect(true);
			return;
		}

		// Usuario autenticado pero sin permiso
		if (requiredRole && userRole !== requiredRole) {
			dispatch(showNoPermission());
			setRedirect(true);
			return;
		}

		// Si todo está bien
		setAllowRender(true);
	}, [authReady, userName, userRole, requiredRole, dispatch]);

	if (!authReady) {
		return <LoadingOverlay />;
	}

	if (redirect) {
		return <Navigate to="/" replace />;
	}

	if (!allowRender) {
		return null; // mientras decide qué hacer
	}

	return children;
};

export default ProtectedRoute;
